import clsx from 'clsx';
import { getImageProps } from '@hungryroot/image';
import { Heading, Paragraph } from '@hungryroot/ramen';
import { useSelectedGroceryCategory } from '../hooks/useSelectedGroceryCategory';
import styles from './GroceryCategoryCard.module.css';
import sharedCardStyles from './sharedCardStyles.module.css';

type GroceryCategoryCardProps = {
  selectedCategory: number;
};

export function GroceryCategoryCard(props: GroceryCategoryCardProps) {
  const { selectedCategory } = props;

  const { selectedCategory: selectedCategoryData } = useSelectedGroceryCategory(
    { selectedCategory }
  );

  const { name, thumbnail_url, tagline } = selectedCategoryData || {};

  return (
    <div className={clsx(sharedCardStyles.card, styles.card)}>
      <div className={styles.separator} />
      <div className={styles.content}>
        {tagline ? (
          <Heading variant="H2" as="h5">
            {tagline}
          </Heading>
        ) : null}
        <div className={styles['name-image-container']}>
          <Paragraph variant="lead">{name}</Paragraph>
          {thumbnail_url ? (
            <img
              key={thumbnail_url}
              {...getImageProps({ src: thumbnail_url, width: 100 })}
              alt={name}
            />
          ) : null}
        </div>
      </div>
      <div className={styles.separator} />
    </div>
  );
}
